import { MultiSelect, Text } from "designSystem/index";
import React from "react";
import { sortedByGroupItems as originalItems } from "designSystemLegacy/data";
import { cloneDeep } from "lodash";
import CssColumnGrid from "designSystemLegacy/CssColumnGrid";

export default () => {
	const items = cloneDeep(originalItems);

	const values = items.slice(0, 2);

	const itemsWithEmptyGroup = cloneDeep(originalItems);
	itemsWithEmptyGroup.forEach((item) => item.group = item.group === "CA" ? "" : item.group);
	const valuesEmptyGroup = items.slice(1, 2);

	return (
		<CssColumnGrid columns={2}>
			<Text semiBold text="normal" />
			<Text semiBold text="suggested" />
			<MultiSelect
				grouped
				options={items}
				value={values}
			/>
			<MultiSelect
				grouped
				options={items}
				suggestedGroups={[ "CA", "WA" ]}
				value={values}
			/>
			<Text semiBold text="custom options" />
			<Text semiBold text="some ungrouped items" />
			<MultiSelect
				allowCustomOptions
				grouped
				options={items}
				value={values}
			/>
			<MultiSelect
				grouped
				options={itemsWithEmptyGroup}
				value={valuesEmptyGroup}
			/>
		</CssColumnGrid>
	);
};